window.addEventListener('DOMContentLoaded', () => {
    const userAgent = navigator.userAgent;
    const rmsRegex = /RMSInt-Client\/(\d+\.\d+\.\d+)|RMS-Client\/(\d+\.\d+\.\d+)/;
    const match = userAgent.match(rmsRegex);

    const minVersion = '5.5.1';

    if (match && match[1]) {
        const version = match[1];

        if (isVersionLower(version, minVersion)) {
            const updateRmsClientInfoDiv = document.getElementById('update_rms_client_info');
            const loginForm = document.getElementById('login_form');

            if (updateRmsClientInfoDiv && loginForm) {
                updateRmsClientInfoDiv.style.display = 'block';
                loginForm.style.display = 'none';
            }
        }
    }
});

function isVersionLower(currentVersion: string, minVersion: string): boolean {
    const currentParts = currentVersion.split('.').map(Number);
    const minParts = minVersion.split('.').map(Number);

    for (let i = 0; i < minParts.length; i++) {
        if (currentParts[i] < minParts[i]) {
            return true;
        } else if (currentParts[i] > minParts[i]) {
            return false;
        }
    }

    return false;
}
